import { __rest } from 'tslib';
import { isPlatformServer } from '@angular/common';
import { InjectionToken, Directive, Inject, PLATFORM_ID, ElementRef, Renderer2, Optional, Self, NgZone, Input, HostListener, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import Inputmask from 'inputmask';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
class InputMaskConfig {
    constructor() {
        this.isAsync = false;
        this.inputSelector = 'input';
    }
}
InputMaskConfig.ɵfac = function InputMaskConfig_Factory(t) { return new (t || InputMaskConfig)(); };
InputMaskConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InputMaskConfig, factory: InputMaskConfig.ɵfac });

const INPUT_MASK_CONFIG = new InjectionToken('InputMaskConfig');

class InputMaskDirective {
    constructor(platformId, elementRef, renderer, ngControl, config, ngZone) {
        this.platformId = platformId;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.ngControl = ngControl;
        this.ngZone = ngZone;
        /**
         *Helps you to create input-mask based on https://github.com/RobinHerbots/Inputmask
         *Supports form-validation out-of-the box.
         *Visit https://github.com/ngneat/input-mask for more info.
         */
        this.inputMask = {};
        this.defaultInputMaskConfig = new InputMaskConfig();
        this.onInput = (_) => { };
        this.onTouched = (_) => { };
        this.validate = (control) => !control.value ||
            !this.inputMaskPlugin ||
            this.inputMaskPlugin.isValid()
            ? null
            : { inputMask: true };
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
        this.setNativeInputElement(config);
    }
    ngOnInit() {
        if (this.control) {
            this.control.setValidators(this.control.validator
                ? [this.control.validator, this.validate]
                : [this.validate]);
            this.control.updateValueAndValidity();
        }
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.inputMaskPlugin) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.mutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    initInputMask() {
        if (isPlatformServer(this.platformId) ||
            !this.nativeInputElement ||
            !Object.keys(this.inputMask).length) {
            return;
        }
        this.inputMaskPlugin = this.ngZone.runOutsideAngular(() => new Inputmask(this.inputMaskOptions).mask(this.nativeInputElement));
        if (this.control) {
            setTimeout(() => {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.control.updateValueAndValidity();
            });
        }
    }
    ngAfterViewInit() {
        this.initInputMask();
    }
    get inputMaskOptions() {
        const _a = this.inputMask, { parser } = _a, options = __rest(_a, ["parser"]);
        return options;
    }
    writeValue(value) {
        if (this.nativeInputElement) {
            this.renderer.setProperty(this.nativeInputElement, 'value', value !== null && value !== void 0 ? value : '');
        }
    }
    registerOnChange(fn) {
        const parser = this.inputMask.parser;
        this.onInput = (value) => {
            fn(parser && value ? parser(value) : value);
        };
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(disabled) {
        if (this.nativeInputElement) {
            this.renderer.setProperty(this.nativeInputElement, 'disabled', disabled);
        }
    }
    get control() {
        var _a;
        return (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control;
    }
    setNativeInputElement(config) {
        if (this.elementRef.nativeElement.tagName === 'INPUT') {
            this.nativeInputElement = this.elementRef.nativeElement;
        }
        else {
            this.defaultInputMaskConfig = Object.assign(Object.assign({}, this.defaultInputMaskConfig), config);
            if (this.defaultInputMaskConfig.isAsync) {
                // Create an observer instance linked to the callback function
                this.mutationObserver = new MutationObserver((mutationsList) => {
                    var _a;
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            const nativeInputElement = this.elementRef.nativeElement.querySelector(this.defaultInputMaskConfig.inputSelector);
                            if (nativeInputElement) {
                                this.nativeInputElement = nativeInputElement;
                                (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
                                this.initInputMask();
                            }
                        }
                    }
                });
                // Start observing the target node for configured mutations
                this.mutationObserver.observe(this.elementRef.nativeElement, {
                    childList: true,
                    subtree: true,
                });
            }
            else {
                this.nativeInputElement = this.elementRef.nativeElement.querySelector(this.defaultInputMaskConfig.inputSelector);
            }
        }
    }
}
InputMaskDirective.ɵfac = function InputMaskDirective_Factory(t) { return new (t || InputMaskDirective)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(INPUT_MASK_CONFIG), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
InputMaskDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InputMaskDirective, selectors: [["", "inputMask", ""]], hostBindings: function InputMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function InputMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target.value); })("blur", function InputMaskDirective_blur_HostBindingHandler($event) { return ctx.onTouched($event.target.value); });
    } }, inputs: { inputMask: "inputMask" } });
InputMaskDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
    { type: InputMaskConfig, decorators: [{ type: Inject, args: [INPUT_MASK_CONFIG,] }] },
    { type: NgZone }
];
InputMaskDirective.propDecorators = {
    inputMask: [{ type: Input }],
    onInput: [{ type: HostListener, args: ['input', ['$event.target.value'],] }],
    onTouched: [{ type: HostListener, args: ['blur', ['$event.target.value'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[inputMask]'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: InputMaskConfig, decorators: [{
                type: Inject,
                args: [INPUT_MASK_CONFIG]
            }] }, { type: ɵngcc0.NgZone }]; }, { inputMask: [{
            type: Input
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }], onTouched: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }] }); })();

class InputMaskModule {
    static forRoot(config) {
        return {
            ngModule: InputMaskModule,
            providers: [{ provide: INPUT_MASK_CONFIG, useValue: config }],
        };
    }
}
InputMaskModule.ɵfac = function InputMaskModule_Factory(t) { return new (t || InputMaskModule)(); };
InputMaskModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InputMaskModule });
InputMaskModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: INPUT_MASK_CONFIG,
            useClass: InputMaskConfig
        },
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputMaskModule, [{
        type: NgModule,
        args: [{
                declarations: [InputMaskDirective],
                exports: [InputMaskDirective],
                providers: [
                    {
                        provide: INPUT_MASK_CONFIG,
                        useClass: InputMaskConfig
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputMaskModule, { declarations: [InputMaskDirective], exports: [InputMaskDirective] }); })();

const createMask = (options) => typeof options === 'string' ? { mask: options } : options;

/*
 * Public API Surface of input-mask
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InputMaskDirective, InputMaskModule, createMask, InputMaskConfig as ɵa, INPUT_MASK_CONFIG as ɵb };

//# sourceMappingURL=ngneat-input-mask.js.map